const deleteEmptyElementsInObjectRecursive = (jsonObject) => {
  //Near perfect recursion (if not perfect) for FHIR JSON scenarios (i.e. will not handles arrays of arrays)
  //This function will change the object sent to it. It does not make a copy of the object.
  try {
    for (const key in jsonObject) {
      let element = jsonObject[key];
      if (typeof element === "string") {
        jsonObject[key] = element.trim();
      }
      if (element === "DELETEME" || element === "" || element === undefined || element === null ||
        (typeof element === "object" && !Array.isArray(element) && Object.keys(element).length === 0) ||
        (Array.isArray(element) &&
          (element.length === 0 ||
            (element.length === 1 &&
              ((typeof element[0] === "object" && Object.keys(element[0]).length === 0) ||
                (typeof element[0] === "string" && element[0] === "")))))) {
        delete jsonObject[key];
      } else if (typeof element === "object" && !Array.isArray(element)) {
        deleteEmptyElementsInObjectRecursive(element);
        if (Object.keys(element).length === 0) {
          delete jsonObject[key];
        }
      } else if (Array.isArray(element)) {
        for (let subIndex = element.length - 1; subIndex >= 0; subIndex--) {
          if (element[subIndex] === null || element[subIndex] === undefined || element[subIndex] === "") {
            element.splice(subIndex, 1);
          } else if (typeof element[subIndex] === "object") {
            deleteEmptyElementsInObjectRecursive(element[subIndex]);
            if (Object.keys(element[subIndex]).length === 0) {
              element.splice(subIndex, 1);
            }
          }
        }
        if (element.length === 0) {
          delete jsonObject[key];
        }
      }
    }
  } catch (e) {
    console.log(e);
  }
  return jsonObject; //Not necessary since we're passing the function an address of memory and the function is modifying the object directly
}

export default deleteEmptyElementsInObjectRecursive;